import React from 'react';

interface QuickChatActionsProps {
    onQuickMessage: (message: string) => void;
    onClose: () => void;
}

const QuickChatActions: React.FC<QuickChatActionsProps> = ({
    onQuickMessage,
    onClose
}) => {
    const quickMessages = [
        {
            id: 'order-inquiry',
            icon: '📋',
            title: '查询订单信息',
            description: '获取最新的订单状态和详情',
            message: '请帮我查询最新的订单信息',
            bgColor: 'bg-blue-100'
        },
        {
            id: 'project-progress',
            icon: '📈',
            title: '项目进展',
            description: '了解项目当前进度和里程碑',
            message: '请告诉我项目的最新进展情况',
            bgColor: 'bg-green-100'
        },
        {
            id: 'sample-status',
            icon: '🧪',
            title: '样品状态',
            description: '查看样品制作和测试进度',
            message: '请帮我确认样品的当前状态',
            bgColor: 'bg-purple-100'
        },
        {
            id: 'tech-specs',
            icon: '⚙️',
            title: '技术规格',
            description: '获取详细的产品技术参数',
            message: '我想了解一下产品的技术规格和参数',
            bgColor: 'bg-orange-100'
        },
        {
            id: 'tech-support',
            icon: '🛠️',
            title: '技术支持',
            description: '申请技术服务和支持',
            message: '我想申请技术服务支持',
            bgColor: 'bg-red-100'
        },
        {
            id: 'quotation',
            icon: '💰',
            title: '报价咨询',
            description: '获取最新的产品报价',
            message: '请提供最新的报价信息',
            bgColor: 'bg-yellow-100'
        },
        {
            id: 'meeting',
            icon: '📅',
            title: '安排会议',
            description: '预约技术交流会议',
            message: '我想安排一次技术交流会议',
            bgColor: 'bg-indigo-100'
        },
        {
            id: 'after-sales',
            icon: '🔧',
            title: '售后服务',
            description: '处理售后相关问题',
            message: '请协助处理售后服务问题',
            bgColor: 'bg-pink-100'
        }
    ];

    const handleQuickMessage = (message: string) => {
        onQuickMessage(message);
        onClose();
    };

    return (
        <div className="space-y-3">
            {quickMessages.map((item) => (
                <button
                    key={item.id}
                    onClick={() => handleQuickMessage(item.message)}
                    className="w-full flex items-center space-x-4 p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors text-left"
                >
                    <div className={`w-12 h-12 ${item.bgColor} rounded-full flex items-center justify-center`}>
                        <span className="text-xl">{item.icon}</span>
                    </div>
                    <div>
                        <p className="font-medium text-gray-900">{item.title}</p>
                        <p className="text-sm text-gray-500">{item.description}</p>
                    </div>
                </button>
            ))}
        </div>
    );
};

export default QuickChatActions;
